<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" lg="4" md="6" sm="8">
        <ValidationObserver
          ref="loginForm"
          v-slot="{
            // eslint-disable-next-line vue/no-unused-vars
            invalid,
            // eslint-disable-next-line vue/no-unused-vars
            passes,
          }"
        >
          <v-row justify="center" class="pa-0" style="margin-top: -50px">
            <v-col cols="1" style="min-width: 100px">
              <v-img
                height="80"
                width="80"
                :src="require(`@/assets/logo.png`)"
              ></v-img>
            </v-col>
          </v-row>
          <v-form @submit.prevent="passes(submitLogin(form))">
            <v-card class="elevation-12">
              <v-card-title flat class="justify-center ma-6">
                <v-toolbar-title>Přihlášení</v-toolbar-title>
              </v-card-title>
              <v-card-text class="mb-0">
                <VTextFieldWithValidation
                  v-model="form.username"
                  rules="required"
                  outlined
                  dense
                  icon="mdi-account"
                  label="Uživatelské jméno"
                />
                <VTextFieldWithValidation
                  v-model="form.password"
                  rules="required"
                  outlined
                  dense
                  icon="mdi-lock"
                  type="password"
                  label="Heslo"
                />
              </v-card-text>
              <v-card-actions class="pl-4 pr-4 pb-4 pt-0">
                <v-row>
                  <v-col>
                    <v-btn
                      type="submit"
                      block
                      color="primary"
                      class="button--text"
                      height="40px"
                      depressed
                      :loading="isLoggin"
                    >
                      Přihlásit se
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
            <v-alert v-if="errorMessage" type="error" class="mt-4">
              {{ errorMessage }}
            </v-alert>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
      errorMessage: null,
      isLoggin: false,
    };
  },
  methods: {
    ...mapActions({
      login: 'auth/login',
    }),
    submitLogin(form) {
      if (!this.form.username.length || !this.form.username.length) return;

      this.errorMessage = null;
      this.isLoggin = true;
      this.login(form)
        .then(() => {
          this.$router.push({
            name: 'printers',
          });
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.errorMessage = 'Přihlašovací údaje nejsou správné.';
          }
        })
        .finally(() => {
          this.isLoggin = false;
        });
    },
  },
};
</script>
